import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const NotFoundPage = () => (
  <main data-testid="not-found" className="pt-[72px] min-h-screen flex items-center">
    <div className="shg-container text-center py-32">
      <div className="font-display text-[20vw] md:text-[200px] leading-none" style={{ color: "var(--red)" }}>404</div>
      <h1 className="font-display text-4xl md:text-5xl mt-4 mb-4">This stand isn&apos;t built — yet.</h1>
      <p className="text-[var(--text-soft)] mb-8 max-w-md mx-auto">
        The page you were looking for doesn&apos;t exist. Let&apos;s get you back to the main floor.
      </p>
      <Link to="/" className="btn-primary"><ArrowLeft size={16} /> Back to home</Link>
    </div>
  </main>
);

export default NotFoundPage;
